
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class AccountService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    list(query?: any) {
        return this.get('/accounts',query);
    }

    create(body: any) {
        return this.post('/account',body);
    }

    find(id) {
        return this.get('/account/'+id);
    }

    update(id, body) {
        return this.put('/account/'+id, body);
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Account.service.ts